import type { ISortCriteria } from "@/lib/shared/types/pagination";

/** Default storefront sort for products with the `new` label. */
export const NEW_ARRIVAL_PRODUCT_SORT: ISortCriteria = {
  criteria: "createdAt",
  order: "desc",
};

export function isNewArrivalLabels(labels: string[]): boolean {
  return labels[0] === "new";
}

export function productSortForLabels(labels: string[]): ISortCriteria | undefined {
  return isNewArrivalLabels(labels) ? NEW_ARRIVAL_PRODUCT_SORT : undefined;
}
